import CharactersView from '../views/CharactersView.vue'
// import CharacterAdjustmentsView from "../views/CharacterAdjustmentsView.vue";
//----------------------------
// routes
//----------------------------
export default [
  // *** NEED ONE FOR ARENA SPECIFIC, OTHER ALL CHARS, THEN MY CHARS
  {
    path: '/manage-combat/characters/',
    name: 'combatCharacters',
    component: CharactersView,
    props: { listScope: 'campaign' },
    meta: { title: 'Characters', requiresAuth: true },
  },
  // {
  //   path: "/character-adjustments/:adjs/:adj_type/:characteristic?",
  //   name: "characterAdjustments",
  //   component: CharacterAdjustmentsView,
  //   props: true,
  //   meta: { title: "Character Sheet Adjustments", requiresAuth: true },
  // },
]
